export const DEFAULT_CONFIG = {
    duration: 5000,
    animate: true,
    placement: 'topRight',
};
